import { sendWebsocketMessage } from '../../../../../../App';

export function unpauseAllTradePlans(){
  const msg = {
    messageType: 'unpauseAllTradePlans'
  };

  sendWebsocketMessage(msg);
}
